import { environment as env } from "../../../environments/environment";

import { HttpClientModule, HttpHeaders } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { Apollo, ApolloModule } from "apollo-angular";
import { HttpLink, HttpLinkModule } from "apollo-angular-link-http";
import { InMemoryCache, IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
import { FetchPolicy } from "apollo-client";
import { from } from "apollo-link";
import { setContext } from "apollo-link-context";
import { AuthService } from "../auth/auth.service";

const fragMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData: {
        __schema: {
            types: [
                {
                    kind: "UNION",
                    name: "SearchResult",
                    possibleTypes: [
                        {
                            name: "PartialFeature",
                        },
                        {
                            name: "PartialSeries",
                        },
                        {
                            name: "PartialSeason",
                        },
                        {
                            name: "PartialEpisode",
                        },
                    ],
                },
            ],
        },
    },
});

@NgModule({
    exports: [
        HttpClientModule,
        ApolloModule,
        HttpLinkModule,
    ],
})

export class ApolloBootstrapModule {
    constructor(
        apollo: Apollo,
        httpLink: HttpLink,
        auth: AuthService,
    ) {
        const uri = `${env.apiPath}/graphql`;
        const http = httpLink.create({uri});
        const cache = new InMemoryCache({
            fragmentMatcher: fragMatcher,
        });
        const middleware = setContext(() => ({
            headers: new HttpHeaders().set("Authorization", auth.bearerToken),
        }));

        apollo.create({
            link: from([middleware, http]),
            cache,
        });
    }
}

export const fetchPolicy: FetchPolicy = "network-only";
